import gql from "graphql-tag";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {isTruthy} from "@khanacademy/wonder-stuff-core";
import {useFastlyQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {GetStandardRegionName} from "@khan/standards-util";

import type {standardRegionsForRegionPickerQueryType} from "./__graphql-types__/index.ts";
import type {standardRegionsForRegionPickerQuery} from "./__graphql-types__/standardRegionsForRegionPickerQuery.ts";

interface StandardRegion {
    id: string;
}

interface StandardRegionPickerOption {
    id: string;
    label: string;
}

export const REGION_PICKER_QUERY: GqlOperation<
    standardRegionsForRegionPickerQueryType["response"],
    standardRegionsForRegionPickerQueryType["variables"]
> = gqlOp(gql`
    query standardRegionsForRegionPickerQuery {
        standardRegions {
            standardRegion {
                id
            }
        }
    }
`);

export const useRegionPickerQuery = (): Array<StandardRegion> => {
    const result = useFastlyQuery(REGION_PICKER_QUERY);
    return mapDataToResult(result);
};

export const mapDataToResult = (
    result: Result<standardRegionsForRegionPickerQuery>,
): Array<StandardRegion> => {
    // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'Result<{ standardRegions: standardRegionsForRegionPickerQuery_standardRegions[]; }>'.
    const standardRegions = result.data?.standardRegions;
    if (!standardRegions) {
        return [];
    }
    return standardRegions
        .map(({standardRegion}) => {
            if (!standardRegion) {
                return null;
            }
            return {
                id: standardRegion.id,
            };
        })
        .filter(isTruthy)
        .sort((a: StandardRegion, b: StandardRegion) => {
            return a.id.localeCompare(b.id);
        });
};

export const getSortedRegionPickerOptions = (
    sortedStandardRegionIDs: Array<StandardRegion>,
): Array<StandardRegionPickerOption> => {
    return sortedStandardRegionIDs
        .map((standardRegion) => {
            return {
                id: standardRegion.id,
                label: GetStandardRegionName(standardRegion.id),
            };
        })
        .sort(
            (a: StandardRegionPickerOption, b: StandardRegionPickerOption) => {
                return a.label.localeCompare(b.label);
            },
        );
};

export default useRegionPickerQuery;
